import useVisitorGeo from '@/hooks/use-visitor-geo';
import { isNorthAmerica } from '@/lib/visitor-geo';

/**
 * Renders `children` only for visitors we positively know are outside North
 * America.
 *
 * Renders nothing on the server, while the location is loading, and when the
 * location is unknown (fail closed), so gated content never reaches server
 * HTML and never flashes for North American visitors.
 *
 *   <OutsideNorthAmerica>
 *     <li><Link href="/currencies">Rates</Link></li>
 *   </OutsideNorthAmerica>
 *
 * This hides UI only. A gated page must also enforce the rule on the server
 * (`geoFromHeaders` + `isNorthAmerica` in getServerSideProps).
 */
const OutsideNorthAmerica = ({ children }) => {
  const geo = useVisitorGeo();

  if (geo.status !== 'ready' || isNorthAmerica(geo)) {
    return null;
  }

  return children;
};

export default OutsideNorthAmerica;
